export enum eStatusProcess{
    'Creado' = 1,
    'Iniciado' = 2,
    'Finalizado' = 3,
    'Con Errores' = 4,
}